<template>
  <button
    @click.prevent="handleClick"
    :disabled="!isInitial"
  >
    <span v-if="replyApproval">
      <span class="font_icon left fa fa-check fa-lg"></span>Approved
    </span>
    <span v-else>
      Approve
    </span>
  </button>
</template>

<script>
const STATE_INITIAL = 0,
  STATE_UPDATING = 1; 

export default {
  name: 'InterfaceApproveButton',
  props: {
    replyId: Number,
    approved: Boolean,
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isUpdating: {
        get () {
            return this.currentState === STATE_UPDATING;
        },
    },
  },
  data: function(){
    return {
      currentState: null,
      replyApproval: null,
    }
  },
  created: function () {
    console.log("InterfaceApproveButton created");
    this.currentState = STATE_INITIAL;
    this.replyApproval = this.approved;
  },
  methods: {
    handleClick() {
      console.log("handleClick");
      if (this.replyApproval) {
        this.replyApproval = false;
      } else {
        this.replyApproval = true;
      }
      this.update();
    },
    update() {
      this.currentState = STATE_UPDATING;
      const self = this;
      const data = {
        reply_id: this.replyId,
        reply_approval: this.replyApproval,
      }

      // console.log(this.data);
      // console.log(window.baseUrl);
      this.axios.post(window.baseUrl + 'api/approve', data).then(response => {
        // console.log(response.data.responseResult.data);
        console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onUpdateComplete();
      });
    },
    onUpdateComplete() {
      this.currentState = STATE_INITIAL;
    },
  }
}
</script>
